export default __webpack_public_path__ + "media/zurb/img/events/wired/raft/raft-3-6e8221542872f0999a349e73ff2e18f5.png";